import { Button, Typography } from "@mui/material";
import { palette } from "../palette";

export default function HomeButton() {
  return (
    <Button color="inherit" onClick={() => window.location.reload()}>
      <Typography
        variant="subtitle1"
        sx={{
          fontFamily: "HUsansNormal",
          color: palette.HUBlauw,
          fontSize: "33px",
        }}
        color="inherit"
      >
        CoPain digitale leeromgeving
      </Typography>
    </Button>
  );
}
